import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';


const TopBreadcumb = props => {

    //const classType = `btn btn-${props.bsSize} btn-${props.bsStyle}`;

    const checkSlash = (url) => {
        let correctUrl = url;
        if (Boolean(url) && url.indexOf('/') !== 0) {
            correctUrl = `/${url}`;
        }
        return correctUrl;
    }

    const renderHomeLink = () => {
        return (<li>
            <Link to={props.homeUrl}
                  className={'breadcrumbLink'}
            >
                <i className='fa fa-lg fa-home'></i> Home
            </Link></li>)
    }

    const renderOtherLinks = () => {
        if (props.links.length > 0) {
            const linksComponent = props.links.map((link, index) => {
                if (index == props.links.length - 1) {
                    return (<li key={index}>
                        <Link
                            key={index}
                            to={checkSlash(link.addressUrl)}
                            style={{cursor: 'default'}}
                            className={'currentBreadcrumbLink'}
                        >
                            {link.text}
                        </Link>
                    </li>);
                } else {
                    return (<li key={index}>
                        <Link
                            key={index}
                            to={checkSlash(link.addressUrl)}
                            className={'breadcrumbLink'}
                        >
                            {link.text}
                        </Link>
                    </li>);
                }
            });
            return linksComponent;
        }
    }
    return (
        <ol className="breadcrumb" style={{display: 'inline-block'}}>
            {renderHomeLink()}
            {renderOtherLinks()}
        </ol>
    );

};

TopBreadcumb.propTypes = {
    bsSize: PropTypes.string,
    bsStyle: PropTypes.string,
    homeUrl: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(PropTypes.shape({
        addressUrl: PropTypes.string,
        text: PropTypes.string
    }))
};

TopBreadcumb.defaultProps = {
    bsSize: 'sm',
    bsStyle: 'primary', //To choose: default, primary, success, info, warning, danger. This is based on file breadcumb.css
    homeUrl: '/',
};

export default TopBreadcumb;


// WEBPACK FOOTER //
// ./src/componentsTopsa/breadcrumbs/TopBreadcumb.js